var core = require('./core_last.js');

$(document).ready(function () {
    $('body,html').animate({
        scrollTop: 0
    }, 400);
    getListOrgsforUsl();

    $('.list_type_org_container').draggable();
});

/**
* Метод для построения запросов на сервер
* @param {any} url
* @param {any} caption
* @param {any} body
*/
var _fetchAsync = async (url, caption, body = null) => {
    let jb = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };

    if (body !== null) {
        let sendJSON = JSON.stringify(body);
        jb.body = "{inputsParam:'" + sendJSON + "'}";

    }
    const promise = await fetch(url + caption, jb);
    return await promise.json();
};


function getListOrgsforUsl() {
    let send = core.urlToObj(false);
    if (send != null && send.uslId != null)
    {
        core.startLoadingAnimation();
        $('.list_type_org_container').show();
        core.sentAjaxTo('GetListOrgFromUsl', send);
    }
    else 
        $('.list_type_org_container').hide();
}


export function setListOrgFromUsl(resp) {
    let info = resp.info;
    let htmTxt = '';
    $('.block_header').html(resp.description);
    $('.list_type_org_count').html(info.length + ' организаций');
    info.forEach((value, index, info) => {
        htmTxt += '<div class="org_card card" id="' + value.id + '"><div class="org_card_block card-block">';
        htmTxt += '<h6 class="org_card_title card-title">' + value.naimk + '</h6>';
        htmTxt += '<p class="card-text org-card-text" style="text-align:left">' + value.fra_addr + '</p>';
        htmTxt += '<p class="card-text org-card-text">Тел.: ' + value.ntel + '</p>';
        htmTxt += '<a href="./org_last.html?id=' + value.id + '" class="org-card-link">Подробнее</a></div ></div > ';
    })

    $('.list_type_org__body').html(htmTxt);

}


//свернуть развернуть
//header = true иконка заголовка иначе иконка из списка
export function toggleElmnts(id, header) {
    let strClass = $('#' + id).find('i').attr('Class'),
        strStart = $('#' + id).find('i').attr('Class').indexOf(!header ? 'fa-toggle' : 'fa-chevron'),
        tStr = strClass.slice(strStart, strClass.length),
        strEnd = tStr.indexOf(' '),
        className = tStr.slice(0, (strEnd == -1 ? tStr.length : strEnd));

    if (!header) {
        if (className === 'fa-toggle-off')
            $('#' + id).find('i').removeClass('fa-toggle-off').addClass('fa-toggle-on');
        else
            $('#' + id).find('i').removeClass('fa-toggle-on').addClass('fa-toggle-off');
        event.stopPropagation();
    }
    else {
        if (className === 'fa-chevron-up')
            $('#' + id).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        else
            $('#' + id).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
        $('#list_collapse').toggle(200);
    }
}

ymaps.ready(init);

function init() {

    var myMap = new ymaps.Map('map_usl', {
        center: core.getCoord(),
        zoom: 8,
        controls: ['zoomControl', 'typeSelector', 'fullscreenControl']
    }, {
            searchControlProvider: 'yandex#search'
        }),

        objectManager = new ymaps.ObjectManager({
            clusterize: false,
            gridSize: 64,
            clusterDisableClickZoom: true
        });


    //objectManager.objects.options.set('preset', 'islands#greenDotIcon');
    objectManager.clusters.options.set('preset', 'islands#invertedDarkBlueClusterIcons',
        'groupByCoordinates', 'false',
        'clusterDisableClickZoom', 'true',
        'clusterHideIconOnBalloonOpen', 'false',
        'geoObjectHideIconOnBalloonOpen', 'false',
        'gridSize', '64',
        'clusterDisableClickZoom', 'true');

    //обработка клика по организации 
    $('.list_type_org__body').on('click', function (e) {
        var id = $(e.target).closest('.card').attr('id');
        var objectState = objectManager.getObjectState(id);

        if (objectState.isClustered) {
            objectManager.clusters.state.set('activeObject', objectManager.objects.getById(id));
            objectManager.clusters.balloon.open(objectState.cluster.id);
        } else {
            objectManager.objects.balloon.open(id);
        }
    })



    let send = core.urlToObj(false);
    let sendJSON = JSON.stringify(send);
    core.startLoadingAnimation();
    $.ajax({
        type: "Post",
        url: "./ASPWebDataServise.asmx/GetListOrgFromUsl",
        data: "{inputsParam:'" + sendJSON + "'}",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            let resp = JSON.parse(response.d)
            let info = resp.info;
            let coordInfo = {
                sumLat: 0,
                sumLong: 0,
                lngth:0
            }            
            info.forEach(async (value, index, info) => {     
                let lat = parseFloat(value.latitude)
                let long = parseFloat(value.longitude)
                if ('latitude' in value && 'longitude' in value && lat && long && lat < 90 && long < 180)
                    AddItemNew(value, [value.longitude, value.latitude], coordInfo, index)
                else {
                    await AddItem(value, index, coordInfo);
                }
                if (index == info.length - 1) {      
                    let coord;
                    let centerCoord = core.getCoord()
                    if (centerCoord[0] && centerCoord[1])
                        coord = centerCoord
                    else                         
                        coord = [coordInfo.sumLong / coordInfo.lngth, coordInfo.sumLat / coordInfo.lngth]
                    if (coordInfo.lngth)
                        myMap.setCenter([coord[0], coord[1]], 7, {
                            checkZoomRange: false
                        })
                }
            })           

            if (resp.length > 1)
                setTimeout(function () {
                    myMap.setBounds(myMap.geoObjects.getBounds());
                }, 1500);           

            core.stoptLoadingAnimation();
        },
        error: function (request, error) {
            alert('error');
        }
    });

    function AddItemNew(org, arrPoint, coordInfo, ind) {        
        if (arrPoint && arrPoint[0] && arrPoint[1]) {
            coordInfo.sumLat += parseFloat(arrPoint[0])
            coordInfo.sumLong += parseFloat(arrPoint[1])
            coordInfo.lngth++;
        }
        objectManager.add(createElemObjManager(org, arrPoint, ind));
        myMap.geoObjects.add(objectManager);
    }

    function AddItem(org, ind, coordInfo) {
        let key = core.getApiKey(),
        url = 'https://geocode-maps.yandex.ru/1.x/?apikey=' + key +'&format=json&geocode=' + JSON.stringify(org.fra_addr);
        let prom = $.get(url, function (data) {            
            var arrPoint = data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
            if (arrPoint && arrPoint[0] && arrPoint[1]) {
                coordInfo.sumLat += parseFloat(arrPoint[0])
                coordInfo.sumLong += parseFloat(arrPoint[1])
                coordInfo.lngth++;
            }
            objectManager.add(createElemObjManager(org, arrPoint, ind));
            myMap.geoObjects.add(objectManager);
            
            _fetchAsync("./ASPWebDataServise.asmx/", 'SetContactCoordinate', {
                orgId: org.id,
                latitude: arrPoint[1],
                longitude: arrPoint[0]
            });
        }).catch(_ => { console.error('Произошла ошибка при попытке получения адреса от яндекса: ' + JSON.parse(_.responseText).message) });
        return prom
    }

    function createCollectionObjManager(org, arrPoint, ind) {
        var feturesArr = [];
        feturesArr.push(createElemObjManager());

        var obj = {};
        obj.type = "FeatureCollection";
        obj.features = feturesArr;
        return obj;
    }

    function getColor(vidId) {
        var id = parseInt(vidId);
        var colorArr = ['#4682B4', '#FF4500', '#8A2BE2', '#A52A2A', '#0000FF', '#5F9EA0',
            '#FF0000', '#2E8B57', '#6A5ACD', '#FF6347',
            '#00FFFF', '#00008B', '#008B8B', '#B8860B', '#006400',
            '#8B008B', '#556B2F', '#FF8C00', '#8B0000', '#483D8B',
            '#2F4F4F', '#1E90FF', '#228B22', '#FF00FF', '#FFD700',
            '#20B2AA', '#87CEFA', '#0000CD', '#9370DB', '#FFA500',
            '#7FFF00', '#D2691E', '#FF7F50', '#6495ED', '#DC143C'
        ];

        var color = colorArr[0];

        if (id >= colorArr.length) {
            var colorId = Math.floor(colorArr.length / id);
            color = colorArr[colorId];
        }
        else
            color = colorArr[id];
        return color;
    }

    function rtrnBalun(value) {
        var txt = '<div class="balun-content">';
        txt += '  <div class="d-flex flex-column">';
        txt += '<div class="p-0 rbx-item-heder">' + value.naimk + '</div>';
        txt += ' <div class="pl-2 rbx-item-addr"><span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span> ' + value.fra_addr + '</div>';
        txt += '<div class="pl-2 rbx-item-addr"><span class="glyphicon glyphicon-phone-alt" aria-hidden="true"></span> ' + value.ntel + '</div>';
        txt += ' <div class="d-flex flex-row justify-content-center mt-2"><a href="./org_last.html?id=' + value.id + '" class="rbx-item-link pl-4"> <span class="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>Перейти в паспорт поставщика</a></div>';
        txt += '</div></div>';
        return txt;
    }

    function createElemObjManager(org, arrPoint, ind) {
        var obj = {};

        var geom = {};
        geom.type = 'Point',
            geom.coordinates = [arrPoint[1], arrPoint[0]];

        var prpty = {};
        prpty.id = org.id;
        prpty.balloonContent = rtrnBalun(org);
       // prpty.balloonContent = "<a class=\"ssilka\">" + org.naimk + "</a><table><tr><td width=\"300px\">" + org.fra_addr + "<br>" + (org.ntel != '' ? " Тел.: " + org.ntel : '') + " </br><a class=\"ssilka\" href=\"./org_last.html?id=" + org.id + "\">подробнее...</a></td><td width=\"100px\"><img width=\"100px\" src=\"./images/logo.png\"></td></tr></table>",
            prpty.clusterCaption = '<a class=\"ssilka\">Организация № ' + (ind + 1) + ' </a>',
            prpty.hintContent = org.naimk
            //prpty.iconCaption = org.id


        var opt = {};
        opt.preset = 'islands#StretchyIcon',
            opt.iconColor = getColor(1),
            opt.hideIconOnBalloonOpen = false;

        obj.type = 'Feature',
            obj.id = org.id,
            obj.vid = 0,
            obj.geometry = geom,
            obj.properties = prpty,
            obj.options = opt;

        return obj;

    }

}